import {useState} from "react";

class PriceService {
  constructor() {
    this.portail = [];
    this.portailPrices = [];
    this.formsPrices = [];
    this.options = [];
    this.modules = [];
  }

  getPortail() {
    return [
        {id: 0, label: "Accès au Portail d’urbanisme", value:true},
        {id: 1, label: "Calcul des contraintes à la parcelle", value:true},
        {id: 2, label: "Impression et outils de mesure", value:true},
        {id: 3, label: "Accès aux règlements", value:true},
        {id: 4, label: "Relevé de propriétaire", value:true},
        {id: 5, label: "Edition de formulaire", value:true},
        {id: 6, label: "Mise à jour en continu", value:true},
        {id: 7, label: "Utilisateur interne", value:true},
        {id: 8, label: "Utilisateur externe", value:false},
        {id: 9, label: "Réseaux d’eaux, électrique...", value:false},
    ];
  }

  getPortailPrices() {
      return [
          {id:0, code:"Pro", "level": 'na', ref: "Professionnel", price:49900, period:"mois", title: "PRO", subtitle: "Abonnement PRO", options:[{val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null},{val:true,nb:null}, {val:true,nb:4}] },
          {id:10, code:"Pro+", "level": 'na', ref: "Professionnel", price:89900, period:"mois", title: "PRO+", subtitle: "Abonnement PRO+", options:[{val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null},{val:true,nb:null}, {val:true,nb:4}] },
          {id:11, code:"Solaire", "level": 'na', ref: "Solaire", price:79900, period:"mois", title: "SOLAIRE", subtitle: "Abonnement Solaire", options:[{val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null},{val:true,nb:null}, {val:true,nb:4}] },

      ]
  }

  getFormsPrices() {
      return [

          {id:0, code:"ru", "level": 'basic', ref: "ru", price:0, unit:"unité", name: "RU", title: "RENSEIGNEMENT D’URBANISME", subtitle: "Renseignement d'urbanisme",
              description: "La note de renseignement d'urbanisme a pour vocation d'informer sur le droit applicable au terrain au moment où elle est établie.",
              url: "/img/samples/sample_cua.pdf",
              options:[
                  {title: "Formulaire modifiable", val:true,nb:null},
                  {title: "Numérotation automatique", val:true,nb:null},
                  {title: "Import des données d’urbanisme et precriptions", val:false,nb:null},
                  {title: "Paragraphe paramètrable", val:false,nb:null}
              ],
          },
          {id:1, code:"cua", "level": 'basic', ref: "cua", price:0, unit:"unité", name: "CUA", title: "CERTIFICAT D’URBANISME INFORMATIF", subtitle: "Certificat d’urbanisme informatif",
              description: "Le certificat d'urbanisme CUA est un document d'information, ce n'est pas une autorisation. Il donne les règles d'urbanisme sur un terrain donné.",
              url: "/img/samples/sample_cua.pdf",
              options:[
                  {title: "Formulaire modifiable", val:true,nb:null},
                  {title: "Numérotation automatique", val:true,nb:null},
                  {title: "Import des données d’urbanisme et precriptions", val:false,nb:null},
                  {title: "Paragraphe paramètrable", val:false,nb:null},
                  {title: "Droit de préemption", val:false,nb:null},
                  {title: "Taxe paramétrable", val:false,nb:null},
              ]
          },
          {id:2, code:"cub", "level": 'basic', ref: "cub", price:0, unit:"unité", name: "CUB", title: "CERTIFICAT D’URBANISME INFORMATIF", subtitle: "Certificat d’urbanisme opérationnel",
              description: "Le certificat d'urbanisme CUB est un document d'information, ce n'est pas une autorisation. Il renseigne sur la faisabilité d'un projet.",
              url: "/img/samples/sample_cua.pdf",
              options:[
                  {title: "Formulaire modifiable", val:true,nb:null},
                  {title: "Numérotation automatique", val:true,nb:null},
                  {title: "Import des données d’urbanisme et precriptions", val:false,nb:null},
                  {title: "Paragraphe paramètrable", val:false,nb:null},
                  {title: "Droit de préemption", val:false,nb:null},
                  {title: "Taxe paramétrable", val:false,nb:null},
              ]
          },
          {id:3, code:"rupro", "level": 'pro', ref: "rupro", price:99 , unit:"unité", name: "RU", title: "RENSEIGNEMENT D’URBANISME", subtitle: "Renseignement d'urbanisme",
              description: "La note de renseignement d'urbanisme a pour vocation d'informer sur le droit applicable au terrain au moment où elle est établie.",
              url: "/img/samples/sample_cua.pdf",
              options:[
                  {title: "Formulaire modifiable", val:true,nb:null},
                  {title: "Numérotation automatique", val:true,nb:null},
                  {title: "Import des données d’urbanisme et precriptions", val:true,nb:null},
                  {title: "Paragraphe paramètrable", val:true,nb:null}
              ],
          },
          {id:4, code:"cuapro", "level": 'pro', ref: "cuapro", price:99, unit:"unité", name: "CUA", title: "CERTIFICAT D’URBANISME INFORMATIF", subtitle: "Certificat d’urbanisme informatif",
              description: "Le certificat d'urbanisme CUA est un document d'information, ce n'est pas une autorisation. Il donne les règles d'urbanisme sur un terrain donné.",
              url: "/img/samples/sample_cua.pdf",
              options:[
                  {title: "Formulaire modifiable", val:true,nb:null},
                  {title: "Numérotation automatique", val:true,nb:null},
                  {title: "Import des données d’urbanisme et precriptions", val:true,nb:null},
                  {title: "Paragraphe paramètrable", val:true,nb:null},
                  {title: "Droit de préemption", val:true,nb:null},
                  {title: "Taxe paramétrable", val:true,nb:null},
              ]
          },
          {id:5, code:"cubpro", "level": 'pro', ref: "cubpro", price:299, unit:"unité", name: "CUB", title: "CERTIFICAT D’URBANISME INFORMATIF", subtitle: "Certificat d’urbanisme opérationnel",
              description: "Le certificat d'urbanisme CUB est un document d'information, ce n'est pas une autorisation. Il renseigne sur la faisabilité d'un projet.",
              url: "/img/samples/sample_cua.pdf",
              options:[
                  {title: "Formulaire modifiable", val:true,nb:null},
                  {title: "Numérotation automatique", val:true,nb:null},
                  {title: "Import des données d’urbanisme et precriptions", val:true,nb:null},
                  {title: "Paragraphe paramètrable", val:true,nb:null},
                  {title: "Droit de préemption", val:true,nb:null},
                  {title: "Taxe paramétrable", val:true,nb:null},
              ]
          },

      ]
  }

  getOptions(){
      return [
          {id: 0, label: "Portail d'urbanisme"},
          {id: 1, label: "Relevé de propriété"},
          {id: 2, label: "Étude d’impact à la parcelle"},
          {id: 3, label: "Certificat d’urbanisme d’information"},
          {id: 4, label: "Certificat d’urbanisme opéerationnel"},
          {id: 5, label: "Renseignement d’urbanisme"},
          {id: 6, label: "Maintenance et mise à jour"},
          {id: 7, label: "Utilisateurs internes"},
      ]

  }

  getModules(){
      return   [
          {id:0, code:"standard", "level": 'epci', ref: "Standard", price:359, period:"mois", subtitle: "Moins de 50 communes", options:[{val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:4}] },
          {id:1, code:"pro", "level": 'epci', ref: "Professionnel", price:459, period:"mois", subtitle: "De 50 à 100 communes", options:[{val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:5}] },
          {id:2, code:"expert", "level": 'epci', ref: "Expert", price:null, period:"", subtitle: "", options:[{val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:6}] },
          {id:3, code:"standard", "level": 'com', ref: "Standard", price:99, period:"mois", subtitle: "", options:[{val:true,nb:null}, {val:false,nb:null}, {val:true,nb:null}, {val:false,nb:null}, {val:false,nb:null}, {val:false,nb:null}, {val:true,nb:null}, {val:true,nb:2}] },
          {id:4, code:"pro", "level": 'com', ref: "Professionnel", price:179, period:"mois", subtitle: "", options:[{val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:false,nb:null}, {val:false,nb:null}, {val:true,nb:null}, {val:true,nb:3}] },
          {id:5, code:"expert", "level": 'com', ref: "Expert", price:null, period:"mois", subtitle: "", options:[{val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:null}, {val:true,nb:4}] },
      ]
  }
}

export default PriceService;
